import { render, staticRenderFns } from "./KardexProductos.vue?vue&type=template&id=450d591c&scoped=true"
import script from "./KardexProductos.vue?vue&type=script&lang=js"
export * from "./KardexProductos.vue?vue&type=script&lang=js"
import style0 from "./KardexProductos.vue?vue&type=style&index=0&id=450d591c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450d591c",
  null
  
)

export default component.exports